import React from 'react';
import {withRouter} from "./withRouter";
import {NavLink} from "react-router-dom";
import {Button, Col, Container, Modal, Row} from "react-bootstrap";

class CreateCompany extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            paymentData: null,
            paymentDataIsLoaded: false,
            show: false,
            isLoaded: true,
            settings: null,
            isSettingsLoaded: false,
        };

        console.log(JSON.stringify(props));
    }

    componentDidMount() {
        this.loadPaymentDataForUser(this.props.userId);

        fetch(process.env.REACT_APP_API_URL + "/settings/1", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    console.log(result);
                    this.setState({
                        isSettingsLoaded: true,
                        settings: result
                    });
                },
                (error) => {
                    this.setState({
                        isSettingsLoaded: true,
                        error
                    });
                }
            )
    }

    loadPaymentDataForUser(userId){
        fetch(process.env.REACT_APP_API_URL + "/my-account/"+userId+"/card/default", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        paymentData: result,
                        paymentDataIsLoaded: true
                    });
                },

                (error) => {
                    console.log(error);

                    this.setState({
                        paymentDataIsLoaded: false,
                        error
                    });
                }
            )
    }

    handleSubmit(e) {
        e.preventDefault();

        console.log(JSON.stringify(this.props));

        const { navigate } = this.props;

        let typeFull = e.target.full_type.checked;

        let card = null;

        this.setState({
            isLoaded: false,
        });

        if (!this.state.paymentData.hasOwnProperty('number')) {
            card = {
                'number': e.target.card_number.value,
                'cvc': e.target.card_cvc.value,
                'exp_month': e.target.card_exp_month.value,
                'exp_year': e.target.card_exp_year.value,
            };
        }

        const companyData = {
            'name': e.target.name.value,
            'site': e.target.site.value,
            'description': e.target.description.value,
            'phone_number': e.target.phone_number.value,
            'publisher_id': this.props.userId,
            'team_members': [],
            'type_full': typeFull,
            'address': {
                'line1': e.target.address_line1.value,
                'postal_code': e.target.address_postal_code.value,
                'city': e.target.address_city.value,
                'state': e.target.address_city.value,
                'country': e.target.address_country.value,
            },
        };

        const cardData = typeFull ? card : null;

        const body = {'company': companyData, 'card': cardData};

        console.log(body);

        fetch(process.env.REACT_APP_API_URL + '/publisher/company', {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
            (result) => {
                this.setState({
                    isLoaded: true
                });

                navigate('/account');
            },
            (error) => {
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        );
    }

    hideOrShowCardForm(){
        let form = document.getElementById('card_data');
        let currentCard = document.getElementById('current_card');
        let infoForFreeType = document.getElementById('infoForFreeType');

        if (form != null) {
            if (form.style.display === 'none') {
                form.style.display = 'block';
                infoForFreeType.style.display = 'none';
            } else {
                form.style.display = 'none';
                infoForFreeType.style.display = 'block'
            }
        }

        if (currentCard != null) {
            if (currentCard.style.display === 'none') {
                currentCard.style.display = 'block';
                infoForFreeType.style.display = 'none'
            } else {
                currentCard.style.display = 'none';
                infoForFreeType.style.display = 'block'
            }
        }
    }

    handleClose() {
        this.setState({
            show:false
        })
    }

    handleShow() {
        this.setState({
            show: true,
        })
    }

    render() {
        const { error, isLoaded, paymentData, paymentDataIsLoaded, settings, isSettingsLoaded } = this.state;

        let paymentDataFormatted = null;
        if (paymentDataIsLoaded && paymentData.hasOwnProperty('number')) {
            paymentDataFormatted = <div id="current_card" class="alert alert-warning">
                <p>Payment Card: <strong>{paymentData.number}</strong></p>

                <NavLink to={{
                    pathname: '/account/' + this.props.userId.toString() + '/payment',
                }} className="btn btn-warning">
                    Edit
                </NavLink>
            </div>
        }

        let content = null;

        if (!isLoaded || !isSettingsLoaded) {
            content = "Loading...";

            return <Container>
                <Row>
                    <Col>
                        {content}
                    </Col>
                </Row>
            </Container>;
        }

        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                {paymentDataIsLoaded ?
                    "Company name is already in use. If you have the rights to use this company name, please, contact support."
                    : <p>Session token has expired. Please, <a href="/account">login</a> again</p>}
            </div> :<empty/>}</div>;
        } else {
            content = (<div class="alert alert-light">
                <h2>Become publisher in few steps!</h2>
                <h6><i>Be careful! Data you will enter will be reviewed by moderators and in case of any mistakes,
                    apps of this company will be declined immediately</i></h6>
                <form onSubmit={this.handleSubmit.bind(this)}>
                    <label>Name: </label>
                    <input class="form-control" required type="text" name="name"/>
                    <br/>
                    <label>Site: </label>
                    <input class="form-control"  required type="url" name="site"/>
                    <br/>
                    <label>About your company: </label>
                    <textarea  class="form-control" name="description"/>
                    <br/>
                    <label>Your phone number: </label>
                    <input  class="form-control" required type="text" name="phone_number"/>
                    <br/>
                    <label>Country: </label>
                    <input class="form-control"  required type="text" name="address_country"/>
                    <br/>
                    <label>State: </label>
                    <input class="form-control"  required type="text" name="address_state"/>
                    <br/>
                    <label>City: </label>
                    <input class="form-control"  required type="text" name="address_city"/>
                    <br/>
                    <label>Postal code: </label>
                    <input  class="form-control" required type="text" name="address_postal_code"/>
                    <br/>
                    <label>Address: </label>
                    <input class="form-control"  required type="text" name="address_line1"/>
                    <br/>

                    {settings.is_paid_company_allowed ?
                        <div>
                        <input className="form-check-input" id="create_new" type="checkbox" defaultChecked={true}
                               name="full_type" onChange={this.hideOrShowCardForm.bind(this)}/>
                        <label className="form-check-label" htmlFor="create_new">Premium version (15$)</label>
                        <br/>
                        <button type="button" className="ms-3 btn btn-info" onClick={this.handleShow.bind(this)}>
                        Benefits
                        </button>
                        <div style={{
                        marginTop: 10,
                        display: "none"
                    }} id="infoForFreeType" class="alert alert-danger">You will be able to create only 5 apps in this company</div>
                        <br/>

                        <Modal show={this.state.show} onHide={this.handleClose.bind(this)}>
                        <Modal.Header closeButton>
                        <Modal.Title>Benefits</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        <ul className="list-group">
                        <li className="list-group-item">Unlimited apps amount per company</li>
                        <li className="list-group-item">Ability to create paid apps</li>
                        <li className="list-group-item">Faster indexing</li>
                        <li className="list-group-item">Faster apps review</li>
                        </ul>
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose.bind(this)}>
                        Ok
                        </Button>
                        </Modal.Footer>
                        </Modal>

                        <br/>
                    {paymentDataFormatted !== null ? paymentDataFormatted : <div id="card_data">
                        <h3>Card data</h3>

                        <label>Card number: </label>
                        <input class="form-control"  type="text" name="card_number"/>
                        <br/>

                        <label>CVC: </label>
                        <input class="form-control"  type="text" name="card_cvc"/>
                        <br/>

                        <label>Expiration month: </label>
                        <input  class="form-control" type="text" name="card_exp_month"/>
                        <br/>

                        <label>Expiration year: </label>
                        <input class="form-control"  type="text" name="card_exp_year"/>
                        <br/>
                        </div>}

                        <br/>
                        </div>
                        : <br/>
                    }
                    <input class="btn btn-success" required type="submit" value="Create company"/>
                </form>
                {/*
                <NavLink to={{
                    pathname: this.props.userId.toString() + '/register-company',
                    state: {userId: this.props.userId},
                }} className="btn btn-success">
                    Register company
                </NavLink>
                */}
            </div>);
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>;
    }
}

export default withRouter(CreateCompany);
